import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import CreatableSelect from 'react-select/creatable';
import {reactSelectStyle} from 'helpers';

const style = {height: 44};
export default React.memo(
  ({
    item,
    prop,
    handleChange,
    setSelectOpen: setSelectOpenMainFunc,
    singleLine,
  }) => {
    const teams = useSelector((state) => state.team.teams);
    const hideDropdown = !!item[prop];
    const selectStyles = useMemo(() => {
      const sharedStyles = reactSelectStyle({hide: hideDropdown});
      if (!singleLine) return sharedStyles;

      return {
        ...sharedStyles,
        control: (base, state) => ({
          ...sharedStyles.control(base, state),
          minHeight: 42,
          height: 42,
        }),
        valueContainer: (base, state) => ({
          ...sharedStyles.valueContainer(base, state),
          height: 42,
          flexWrap: 'nowrap',
          paddingTop: 0,
          paddingBottom: 0,
        }),
        input: (base, state) => ({
          ...sharedStyles.input(base, state),
          margin: 0,
          marginTop: 0,
          // The surrounding box applies a 48px height to all native inputs.
          '& input': {height: '20px !important'},
        }),
      };
    }, [hideDropdown, singleLine]);

    const teamOptions = useMemo(
      () =>
        teams.map((team) => ({
          label: team.name,
          value: {teamName: team.name, teamId: team._id},
        })),
      [teams]
    );

    const name = 'teams';
    const setSelectOpen = setSelectOpenMainFunc(name);

    return (
      <div
        className="input-container custom-input-box box-input-container"
        style={style}
      >
        <div className="d-flex align-items-center box h-100">
          <div className="d-flex justify-content-center align-items-center h-100 select-team-text-container">
            <div className="title">TEAM</div>
          </div>
          <div className="input-container flex-grow-1">
            <CreatableSelect
              isClearable
              menuPlacement="auto"
              styles={selectStyles}
              value={teamOptions.find((t) => t.value.teamName === item[prop])}
              onChange={(newValue) => {
                if (newValue) {
                  handleChange('teamName', newValue.value.teamName);
                  handleChange('teamId', newValue.value.teamId);
                } else {
                  handleChange('teamName', '');
                  handleChange('teamId', '');
                }
              }}
              placeholder=""
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              options={teamOptions}
              onMenuClose={() => {
                setSelectOpen(false);
              }}
              onMenuOpen={() => {
                setSelectOpen(true);
              }}
            />
          </div>
        </div>
      </div>
    );
  }
);
